const MerchantAccountListView = () =>
  import('@/views/MerchantAccounts/MerchantAccountListView/MerchantAccountListView.vue')
const MerchantAccountDetailView = () =>
  import('@/views/MerchantAccounts/MerchantAccountDetailView/MerchantAccountDetailView.vue')
const MerchantAccountCreateView = () =>
  import('@/views/MerchantAccounts/MerchantAccountCreateView/MerchantAccountCreateView.vue')

// The same role the Super Admin Tools menu checks; payment-service's detail answers 403 to anyone else.
const SUPER_ONLY = ['super_admin']

export default [
  {
    path: '/merchants/:merchantID?/locations/:locationID?/merchant-accounts',
    component: MerchantAccountListView,
    name: 'MerchantAccountList',
    meta: { require_roles: SUPER_ONLY }
  },
  {
    path: '/merchants/:merchantID/locations/:locationID/merchant-accounts/create',
    component: MerchantAccountCreateView,
    name: 'MerchantAccountCreate',
    meta: { require_roles: SUPER_ONLY }
  },
  {
    path: '/merchants/:merchantID/locations/:locationID/merchant-accounts/:merchantAccountID',
    component: MerchantAccountDetailView,
    name: 'MerchantAccountDetail',
    meta: { require_roles: SUPER_ONLY }
  }
]
